import {
  consoleFancyClient,
  extractData,
  type fancyOperations,
  type FancyOk
} from '@frontrow/console/src/open-api/clients'

export async function fetchDemoDistrict(): Promise<FancyOk<fancyOperations['getDemoDistrictsR']>> {
  return extractData(await consoleFancyClient.GET('/2/demo-districts'))
}

export async function createOrRefreshDemoDistrict(): Promise<unknown> {
  const {data} = await consoleFancyClient.POST('/2/demo-districts')
  return data
}

export async function fetchExternalDemoDistrict(
  email: string
): Promise<FancyOk<fancyOperations['getExternalDemoDistrictsR']>> {
  return extractData(
    await consoleFancyClient.GET('/2/demo-districts/external', {params: {query: {email}}})
  )
}

export async function createExternalDemoDistrict(email: string): Promise<unknown> {
  const {data} = await consoleFancyClient.POST('/2/demo-districts/external', {body: {email}})
  return data
}
